import React, { useEffect, useState } from 'react';
import { DateBadge } from './base';
import { STAGES } from '../lib/constantes';
import { useNotificationSound } from '../lib/som';

function NotificationBell({ leads, onOpenLead, onDismiss, onStageChange }) {
  const [open, setOpen]       = useState(false);
  const [muted, setMuted]     = useState(false);
  const [alerted, setAlerted] = useState(false);
  const [checking, setChecking] = useState(null); // id do lead sendo marcado
  const playSound = useNotificationSound();

  const today = new Date(); today.setHours(0,0,0,0);
  const overdue = leads.filter(l =>
    l.next_contact_date && !['fechado','perdido'].includes(l.stage) &&
    new Date(l.next_contact_date+'T00:00:00') < today
  );
  const todayLeads = leads.filter(l =>
    l.next_contact_date && !['fechado','perdido'].includes(l.stage) &&
    new Date(l.next_contact_date+'T00:00:00').getTime() === today.getTime()
  );
  const urgent = [...overdue, ...todayLeads];

  useEffect(() => {
    if (urgent.length > 0 && !muted && !alerted) {
      setTimeout(() => playSound(), 1000);
      setAlerted(true);
    }
  }, [urgent.length]);

  const handleOpen = () => {
    setOpen(o => !o);
    if (!open && urgent.length > 0 && !muted) playSound();
  };

  const handleDismiss = async (e, lead) => {
    e.stopPropagation();
    setChecking(lead.id);
    await onDismiss(lead);
    setChecking(null);
  };

  const NotifItem = ({ l, colorHover, isOverdue }) => (
    <div
      key={l.id}
      onClick={()=>{ onOpenLead(l); setOpen(false); }}
      className={`flex items-center gap-2 py-2 cursor-pointer ${isOverdue ? 'hover:bg-red-50' : 'hover:bg-orange-50'} rounded-xl px-2 -mx-2 group transition-colors`}
    >
      {/* Botão de check */}
      <button
        onClick={e => handleDismiss(e, l)}
        disabled={checking === l.id}
        title="Marcar abordagem como feita"
        className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all
          ${checking === l.id
            ? 'border-green-400 bg-green-100'
            : isOverdue
              ? 'border-red-300 hover:border-green-500 hover:bg-green-50 group-hover:border-green-400'
              : 'border-orange-300 hover:border-green-500 hover:bg-green-50 group-hover:border-green-400'
          }`}
      >
        {checking === l.id
          ? <span className="text-green-600 text-xs">✓</span>
          : <span className="text-transparent group-hover:text-green-500 text-xs transition-colors">✓</span>
        }
      </button>
      {/* Info do lead */}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-800 truncate">{l.company_name}</p>
        {onStageChange
          ? <select value={l.stage} title="Mover de etapa" aria-label="Mover de etapa"
              onClick={e=>e.stopPropagation()} onChange={e=>{ e.stopPropagation(); onStageChange(l.id, e.target.value); }}
              className="mt-0.5 t-caption-2 text-gray-500 bg-white border border-gray-200 rounded-lg px-1.5 py-0.5 max-w-[150px] focus:outline-none focus:ring-2 focus:ring-blue-300">
              {STAGES.map(s=><option key={s.key} value={s.key}>{s.label}</option>)}
            </select>
          : <p className="text-xs text-gray-400">{STAGES.find(s=>s.key===l.stage)?.label}</p>}
      </div>
      <DateBadge dateStr={l.next_contact_date} />
    </div>
  );

  return <div className="relative">
    <button onClick={handleOpen} className="relative p-2 rounded-full hover:bg-black/[0.06] transition-colors">
      <span className="text-xl">{urgent.length > 0 ? '🔔' : '🔕'}</span>
      {urgent.length > 0 && (
        <span className="absolute -top-0.5 -right-0.5 bg-red-500 text-white t-caption-2 rounded-full w-4 h-4 flex items-center justify-center font-bold">
          {urgent.length}
        </span>
      )}
    </button>
    {open && <>
      <div className="fixed inset-0 z-40" onClick={()=>setOpen(false)} />
      <div className="animate-fade-in-up absolute right-0 top-11 glass acard rounded-2xl shadow-2xl w-80 z-50 overflow-hidden">
        <div className="px-4 py-3 border-b border-black/[0.06] flex items-center justify-between">
          <span className="font-semibold text-gray-900 t-footnote">Notificações</span>
          <div className="flex items-center gap-3">
            <span className="text-xs text-gray-400">✓ = feita</span>
            <button onClick={()=>setMuted(m=>!m)} className="text-sm text-gray-400 hover:text-gray-700 rounded-full p-1 hover:bg-gray-100">
              {muted ? '🔇' : '🔊'}
            </button>
          </div>
        </div>
        {urgent.length === 0
          ? <div className="text-center py-8">
              <div className="text-3xl mb-2">🎉</div>
              <p className="text-sm text-gray-400">Tudo em dia!</p>
            </div>
          : <div className="max-h-96 overflow-y-auto divide-y divide-black/[0.04]">
              {overdue.length > 0 && <div className="px-4 pt-3 pb-2">
                <p className="t-caption-2 font-bold text-red-500 sf-caption mb-2">⚠️ Atrasados</p>
                {overdue.map(l=><NotifItem key={l.id} l={l} isOverdue={true} />)}
              </div>}
              {todayLeads.length > 0 && <div className="px-4 pt-3 pb-2">
                <p className="t-caption-2 font-bold text-orange-500 sf-caption mb-2">🔔 Hoje</p>
                {todayLeads.map(l=><NotifItem key={l.id} l={l} isOverdue={false} />)}
              </div>}
            </div>}
      </div>
    </>}
  </div>;
}

// ─── ReferralForm (público, sem login) ───────────────────

export { NotificationBell };
